import React, { FC, useMemo } from 'react';
import { StatusBar as RNStatusBar, StatusBarStyle } from 'react-native';

import { useTheme } from '@webtrader/core/services/theme/v2';
import { EThemeScheme } from '@webtrader/core/themes';

interface IProps {}

const StatusBar: FC<IProps> = () => {
  const { theme } = useTheme();

  const statusBarStyle = useMemo<StatusBarStyle>(() => {
    switch (theme.scheme) {
      case EThemeScheme.DARK:
        return 'light-content';
      case EThemeScheme.LIGHT:
        return 'dark-content';
      default:
        return 'default';
    }
  }, [theme]);

  return <RNStatusBar barStyle={statusBarStyle} />;
};

export default StatusBar;
